import { useQuery } from '@tanstack/react-query';
import {
  fetchFacilities,
  fetchFacilitiesFacets,
  type FacilitiesQuery,
  type FacilitiesResponse,
  type FacilitiesFacets,
} from './client.js';

// Map data hooks. The list query is keyed on the filter state only — NOT
// on the map viewport — so panning / zooming re-clusters in memory without
// a network round-trip. The whole filtered set arrives in one request.
//
// `enabled` gates the fetch: the map's query is heavy (it scans every
// geocoded CQC location), so the panel passes `enabled: isVisible` to keep
// it from firing while the Map tab is in the background — otherwise it runs
// on every page load and competes with the screener for the DB pool.

export function useFacilities(query: FacilitiesQuery, opts: { enabled?: boolean } = {}) {
  return useQuery<FacilitiesResponse, Error>({
    queryKey: ['facilities', query] as const,
    queryFn: () => fetchFacilities(query),
    staleTime: 60_000,
    enabled: opts.enabled ?? true,
  });
}

export function useFacilitiesFacets(opts: { enabled?: boolean } = {}) {
  return useQuery<FacilitiesFacets, Error>({
    queryKey: ['facilities-facets'] as const,
    queryFn: fetchFacilitiesFacets,
    staleTime: 5 * 60_000,
    enabled: opts.enabled ?? true,
  });
}
